import React from 'react';
import { Box } from '@mui/material';
import { scrollbarStyle } from '@theme/styles';

type DrawerContentProps = {
  drawerPadding?: string;
  drawerColor?: string;
  children?: React.ReactNode;
};

export const DrawerContent = (props: DrawerContentProps) => {
  const { drawerPadding = '16px', drawerColor = 'background.main', children } = props;
  return (
    <Box
      padding={drawerPadding}
      bgcolor={drawerColor}
      sx={{
        padding: drawerPadding,
        bgcolor: drawerColor,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: '1',
        overflowY: 'auto',
        overflowX: 'hidden',
        ...scrollbarStyle,
      }}
    >
      {children}
    </Box>
  );
};
